import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppsSharedModule } from 'base';
import { WrapperComponent } from './wrapper/wrapper.component';

@NgModule({
  declarations: [WrapperComponent],
  imports: [CommonModule, AppsSharedModule],
  exports: [WrapperComponent],
})
export class LayoutModule {}
